import React, { useState } from 'react'
import './Contact.css'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: '',
  })

  const [formStatus, setFormStatus] = useState('')

  // Reset formStatus after showing success or error message
  React.useEffect(() => {
    if (formStatus === 'success' || formStatus === 'error') {
      const timer = setTimeout(() => setFormStatus(''), 4000)
      return () => clearTimeout(timer)
    }
  }, [formStatus])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setFormStatus('sending')

    const payload = {
      organisation_code: 'Tecmates',
      organisation_id: 33,
      fullname: formData.name,
      email: formData.email,
      // to_email: 'arjunbc43@gmail.com',
      to_email: 'support@tecmatesinfo.com',
      phone: formData.phone,
      subject: 'Tecmates Feedbacks',
      subject_content: formData.service || 'Service of interest',
      message: formData.message || 'Feedback of the above person was submitted',
    }

    try {
      const response = await axios.post(
        'https://gbsemail.mysitegen.com/email/sendFeedBackEmail',
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      )

      if (response.status !== 200) {
        throw new Error('Network response was not ok')
      }

      setFormStatus('success')
      setFormData({
        name: '',
        email: '',
        company: '',
        phone: '',
        service: '',
        message: '',
      })
      toast.success('Thank you! Your message has been sent successfully.')
    } catch (error) {
      setFormStatus('error')
      toast.error('Error submitting form. Please try again.')
      console.error('Error submitting form:', error)
    }
  }

  return (
    <div className='contact-page '>
      {/* Page Header */}
      <section className='page-header'>
        <div className='hero-background'>
          <img
            src='https://plus.unsplash.com/premium_photo-1675842663249-a8b70103dbaa?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
            alt='Contact Hero Background'
          />
          <div className='hero-overlay'></div>
        </div>
        <div className='container'>
          <h1>Contact Us</h1>
          <p>Get in touch with our team of certified professionals</p>
        </div>
      </section>
      {/* Toastify Container */}
      <ToastContainer />
      <section className='contact-section'>
        <div className='container'>
          {/* <div className='contact-hero'>
          <img
            src='https://plus.unsplash.com/premium_photo-1683134214022-86fae451864d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
            alt='Contact Us'
          />
          <div className='contact-hero-content'>
            <h2>Get in Touch</h2>
            <p>
              Ready to accelerate your digital transformation? Our team of
              certified professionals is here to help.
            </p>
          </div>
            </div> */}
          <div className='contact-grid'>
            <div className='contact-form shadow-none bordered'>
              <h3>Send us a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className='form-row'>
                  <div className='form-group'>
                    <label htmlFor='name'>Full Name *</label>
                    <input
                      type='text'
                      id='name'
                      name='name'
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder='Your Full Name'
                      required
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='email'>Email Address *</label>
                    <input
                      type='email'
                      id='email'
                      name='email'
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder='your.email@company.com'
                      required
                    />
                  </div>
                </div>

                <div className='form-row'>
                  <div className='form-group'>
                    <label htmlFor='company'>Company Name</label>
                    <input
                      type='text'
                      id='company'
                      name='company'
                      value={formData.company}
                      onChange={handleInputChange}
                      placeholder='Your Company'
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='phone'>Phone Number</label>
                    <input
                      type='tel'
                      id='phone'
                      name='phone'
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder='+91 98765 43210'
                    />
                  </div>
                </div>

                <div className='form-group'>
                  <label htmlFor='service'>Service of Interest</label>
                  <select
                    id='service'
                    name='service'
                    value={formData.service}
                    onChange={handleInputChange}
                  >
                    <option value=''>Select a Service</option>
                    <option value='infrastructure'>
                      IT Infrastructure Solutions
                    </option>
                    <option value='networking'>
                      Networking & Connectivity
                    </option>
                    <option value='security'>Cybersecurity Solutions</option>
                    <option value='cloud'>Cloud & Virtualization</option>
                    <option value='collaboration'>
                      Collaboration & Communication
                    </option>
                    <option value='managed'>Managed & AMC Services</option>
                    <option value='consulting'>Consulting & Integration</option>
                    <option value='value-added'>Value-Added Services</option>
                  </select>
                </div>

                <div className='form-group'>
                  <label htmlFor='message'>Message *</label>
                  <textarea
                    id='message'
                    name='message'
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder='Tell us about your project requirements...'
                    rows='5'
                    required
                  ></textarea>
                </div>

                <button
                  type='submit'
                  className={`btn btn-primary ${
                    formStatus === 'sending' ? 'loading' : ''
                  }`}
                  disabled={formStatus === 'sending'}
                >
                  {formStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </button>

                {formStatus === 'success' && (
                  <div className='form-success'>
                    <i className='fas fa-check-circle'></i>
                    <p>
                      Thank you! Your message has been sent successfully. We'll
                      get back to you soon.
                    </p>
                  </div>
                )}
              </form>
            </div>

            <div className='contact-info'>
              <h3>Contact Information</h3>

              <div className='contact-item'>
                <i className='fas fa-envelope'></i>
                <div>
                  <h4>Email</h4>
                  <p>info@tecmatesinfo.com</p>
                  <p>support@tecmatesinfo.com</p>
                </div>
              </div>

              <div className='contact-item'>
                <i className='fas fa-phone'></i>
                <div>
                  <h4>Phone</h4>
                  <p>+91 9846789946</p>
                  <p>24/7 Support Available</p>
                </div>
              </div>

              <div className='contact-item'>
                <i className='fas fa-map-marker-alt'></i>
                <div>
                  <h4>Address</h4>
                  <p>TecMates Infocom Pvt Ltd,</p>
                  <p>TC-94/974(5), Ottapurackal building,</p>
                  <p>Vadayakkadu Jn, Kunnukuzhi,</p>
                  <p>Trivandrum-695035</p>
                </div>
                <div>
                  <h4>Branch Address</h4>
                  <p>Kochapilly House No PERA-33,</p>
                  <p>Kochapilly Arcade, Vattathipadam,</p>
                  <p> East road Near Spices Board HO,</p>
                  <p>Palarivattom, Kochi- 682025</p>
                </div>
              </div>

              <div className='contact-item'>
                <i className='fas fa-clock'></i>
                <div>
                  <h4>Business Hours</h4>
                  <p>Monday - Saturday: 9:00 AM - 6:00 PM</p>
                </div>
              </div>

              <div className='social-links'>
                <h4>Follow Us</h4>
                <div className='social-icons'>
                  <a href='#' title='LinkedIn'>
                    <i className='fab fa-linkedin'></i>
                  </a>
                  <a href='#' title='Twitter'>
                    <i className='fab fa-twitter'></i>
                  </a>
                  <a href='#' title='Facebook'>
                    <i className='fab fa-facebook'></i>
                  </a>
                  <a href='#' title='Instagram'>
                    <i className='fab fa-instagram'></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Office Locations */}
      <section className='office-locations'>
        <div className='container'>
          <h2 className='section-title'>Our Office Locations</h2>
          <p className='section-subtitle'>
            Serving clients across multiple locations
          </p>

          <div className='locations-grid'>
            <div className='location-card'>
              <div className='location-icon'>
                <i className='fas fa-building'></i>
              </div>
              <h3>Head Office</h3>

              <p>TC-94/974(5), </p>
              <p> Ottapurackal building, Vadayakkadu Jn</p>
              <p>Kunnukuzhi, Trivandrum-695035</p>
            </div>

            <div className='location-card'>
              <div className='location-icon'>
                <i className='fas fa-map-pin'></i>
              </div>
              <h3>Branch Office</h3>
              <p>Kochapilly House No PERA-33,</p>
              <p>Kochapilly Arcade, Vattathipadam,</p>
              <p>East road Near Spices Board HO,</p>
              <p>Palarivattom, Kochi- 682025</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Contact
